import type { MapLocation, MapViewport } from './types';
import { PLACED_MARKER_ZOOM } from './constants';

export function isPointerOverElement(
  element: Element | null | undefined,
  clientX: number,
  clientY: number,
  padding = 0,
): boolean {
  if (!element) {
    return false;
  }

  const rect = element.getBoundingClientRect();
  return (
    clientX >= rect.left - padding &&
    clientX <= rect.right + padding &&
    clientY >= rect.top - padding &&
    clientY <= rect.bottom + padding
  );
}

export function getResolvedHint({
  hintText,
  readOnly,
  showSearch,
}: {
  hintText?: string;
  readOnly: boolean;
  showSearch: boolean;
}): string {
  if (hintText) {
    return hintText;
  }

  if (readOnly) {
    return 'Location preview.';
  }

  if (showSearch) {
    return 'Type an address in the search box or drag the pin onto the map. To remove it, drag the pin back to its dock on the right side of the map.';
  }

  return 'Drag the pin onto the map. To remove it, drag the pin back to its dock on the right side of the map.';
}

export function getMarkerPlacementViewport(
  justPlaced: boolean,
  markerCenter: google.maps.LatLngLiteral,
  currentViewport: MapViewport,
): MapViewport {
  if (justPlaced) {
    return { center: markerCenter, zoom: PLACED_MARKER_ZOOM };
  }

  return { ...currentViewport, center: markerCenter };
}

export function createClearedLocation(
  location: MapLocation | null | undefined,
): MapLocation {
  return {
    ...(location ?? {}),
    latitude: undefined,
    longitude: undefined,
    streetAddress: undefined,
    city: undefined,
    state: undefined,
    zipcode: undefined,
    formattedAddress: undefined,
    locationName: undefined,
  };
}

export function viewportFromMap(map: google.maps.Map): MapViewport | null {
  const centerLatLng = map.getCenter();
  const zoom = map.getZoom();

  if (!centerLatLng || zoom == null) {
    return null;
  }

  return {
    center: { lat: centerLatLng.lat(), lng: centerLatLng.lng() },
    zoom,
  };
}
